export const RECORD_ID = {
  USER_ATTENDANCE_STATUS: 'UserAttendanceStatus',
};
